import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { find as _find } from 'lodash';

class CmsPageTreeViewSlideout extends React.Component {
  close = e => {
    e.preventDefault();

    const { close } = this.props;
    close();
  };

  getParamValue = (child, paramName) => {
    const param = _find(child.getParams(), ['name', paramName]);
    return param ? param.getValue() : null;
  };

  renderChildren = (children, index = '', depth = 0) => {
    const { navigateSettings } = this.props;

    return children.map((child, i) => {
      const elementIndex = index + (index.length === 0 ? '' : '.') + i;
      const label = this.getParamValue(child, 'elementLabel') || child.getType();
      const hiddenPhone = this.getParamValue(child, 'hiddenPhone') === 'yes';
      const hiddenTablet = this.getParamValue(child, 'hiddenTablet') === 'yes';
      const hiddenDesktop = this.getParamValue(child, 'hiddenDesktop') === 'yes';

      return (
        <React.Fragment key={child.getId() || i}>
          <div className={'m-b-5 bg-master-lightest b-rad-sm padding-5 clearfix m-l-' + depth * 10}>
            <span class="pull-left">{label}</span>
            <span class="pull-right">
              <a href="#settings" onClick={e => navigateSettings(e, elementIndex)} className="text-master">
                <i className="fa-fw fa fa-cog" />
              </a>
              <i className={'fa-fw fas fa-mobile-alt ' + (!hiddenPhone ? 'text-success ' : 'hint-text ')} />
              <i className={'fa-fw fas fa-tablet-alt ' + (!hiddenTablet ? 'text-success ' : 'hint-text ')} />
              <i className={'fa-fw fas fa-desktop-alt ' + (!hiddenDesktop ? 'text-success ' : 'hint-text ')} />
            </span>
          </div>

          {!!child.getChildren() &&
            !!child.getChildren().length &&
            this.renderChildren(child.getChildren(), elementIndex, depth + 1)}
        </React.Fragment>
      );
    });
  };

  render() {
    const { open, page } = this.props;

    return <div className={'padding-10 ' + (open ? '' : 'hide')}>{this.renderChildren(page.getContent())}</div>;
  }
}
CmsPageTreeViewSlideout.defaultProps = {
  open: false,
  page: {},
  close: () => {},
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
  };
};

export default injectIntl(connect(mapStateToProps)(CmsPageTreeViewSlideout));
